import svg from './row-svg/surface-parcelle-v3.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function SurfaceParcelleV3Icon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default SurfaceParcelleV3Icon;
